module.exports = __webpack_public_path__ + "media/images/s03_02_en-e5deba9e077e0ba8ebc0da1c7590293c.svg";